import { store } from "@/store/store";
import { solicitudes_cita_estado_hist } from "@/shared/dtos/solicitudes_cita_estado_hist";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({ namespaced: true, name: "solicitudesCitaEstadoHistModule", store, dynamic: true })
class solicitudesCitaEstadoHistModule extends VuexModule {
  public rows: solicitudes_cita_estado_hist[] = [];
  public row: solicitudes_cita_estado_hist = new solicitudes_cita_estado_hist();

  @Action({ commit: "onGetRows" })
  public async getRows() {
    return await ssmHttpService.get(API.solicitudes_cita_estado_hist);
  }

  @Action({ commit: "onGetRow" })
  public async getRow(id: any) {
    return await ssmHttpService.get(API.solicitudes_cita_estado_hist + "/" + id);
  }

  @Action
  public async guardar(item: solicitudes_cita_estado_hist) {
    return await ssmHttpService.post(API.solicitudes_cita_estado_hist, item.toJson(["created_at"]));
  }

  @Action
  public async modificar(item: solicitudes_cita_estado_hist) {
    return await ssmHttpService.put(API.solicitudes_cita_estado_hist + "/" + item.id, item.toJson(["created_at"]));
  }

  @Action
  public async eliminar(item: solicitudes_cita_estado_hist) {
    return await ssmHttpService.delete(API.solicitudes_cita_estado_hist + "/" + item.id, null, false);
  }

  @Mutation
  public onGetRows(res: solicitudes_cita_estado_hist[]) {
    this.rows = res ? res.map((x) => new solicitudes_cita_estado_hist(x)) : [];
  }

  @Mutation
  public onGetRow(res: solicitudes_cita_estado_hist) {
    this.row = new solicitudes_cita_estado_hist(res);
  }
}

export default getModule(solicitudesCitaEstadoHistModule);
